export const queryKeys = {
  fetch: {
    all: ['fetch'] as const,
    priceValidation: (workflowId: number, fetchId: number) =>
      [...queryKeys.fetch.all, workflowId, fetchId, 'price-validation'] as const,
  },
};
